import React from "react";
import { Table, Button } from "reactstrap";
import { FormattedMessage } from "react-intl";

const NumberOfLicensesTable = (props) => {
  let licenses = props.programLicenses;

  var licensesShow = licenses.map(function (license, i) {
    return (
      <tr key={i}>
        <td style={{ whiteSpace: "nowrap" }}>{license.name}</td>
        <td style={{ textAlign: "right" }}>{license.quantityTotal}</td>
        <td style={{ textAlign: "right" }}>
          <Button
            outline
            color="primary"
            className="mt-0 pt-0"
            onClick={() => props.toggleLicenseDetails("Active", license.name)}
          >
            {license.quantityActive}
          </Button>
        </td>
        <td style={{ textAlign: "right" }}>
          <Button
            outline
            color="primary"
            className="mt-0 pt-0"
            onClick={() => props.toggleLicenseDetails("Expired", license.name)}
          >
            {license.quantityExpired}
          </Button>
        </td>
        <td style={{ textAlign: "right" }}>
          <Button
            outline
            color="primary"
            className="mt-0 pt-0"
            onClick={() => props.toggleLicenseDetails("Expiring", license.name)}
          >
            {license.quantityExpiring}
          </Button>
        </td>
        <td style={{ textAlign: "right" }}>{license.numberOfStudents}</td>
        <td></td>
      </tr>
    );
  });

  return (
    <Table hover responsive className="mb-0">
      <thead>
        <tr>
          <th>
            <FormattedMessage id="Programlicense" />
          </th>
          <th>
            <FormattedMessage id="LicensesTotal" />
          </th>
          <th style={{ whiteSpace: "nowrap" }}>
            <FormattedMessage id="LicensesActive" />
          </th>
          <th style={{ whiteSpace: "nowrap" }}>
            <FormattedMessage id="LicensesExpired" />
          </th>
          <th style={{ whiteSpace: "nowrap" }}>
            <FormattedMessage id="LicensesExpiring" />
          </th>
          <th style={{ whiteSpace: "nowrap" }}>
            <FormattedMessage id="StudentsNumberOf" />
          </th>
          <th style={{ width: "80%" }}></th>
        </tr>
      </thead>
      <tbody>{licensesShow}</tbody>
    </Table>
  );
};

export default NumberOfLicensesTable;
